import DashboardPage from "../../../features/admin/dashboard/dashboard-page";

export default function Dashboard() {
  return <DashboardPage />;
}
